import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input()
  public startButton: string;
  @Input()
  public customButtons;
  @Input()
  public loading;
  @Input()
  public title: string;

  constructor(private translate: TranslateService) { }

  ngOnInit() {}

}
